// The facts the legacy app reads about the signed-in person: role, organization and profile details.
//
// With Auth0 Universal Login they are claims the tenant's Actions add to the tokens
// (`https://dosen.io/role`, `https://dosen.io/organization`, `user_metadata`). A transparent session's
// tokens carry none of them — the API hands the same facts over next to the tokens instead
// (src/auth/session.ts). A role / organization claim the access token does carry wins; the profile
// details are the API's whenever it handed them over (a tenant Action may still stamp a
// `user_metadata` claim on the ID token, but for an account created here it holds nothing).
import jwt_decode from 'jwt-decode';
import { readSessionProfile } from '../auth/session';

export interface SessionClaims {
  /** platform role: 1 member · 2 org admin · 3 platform admin */
  role: number | undefined;
  organization: any;
  userMetadata: any;
  accessData: any;
  idData: any;
}

// The ID token is read only for what it adds: one that is missing adds nothing (never an error —
// callers that only want the organization used to decode the access token alone).
function decodeOrEmpty(token: string): any {
  try {
    return jwt_decode(token);
  } catch {
    return {};
  }
}

export function sessionClaims(accessToken: string, idToken: string): SessionClaims {
  const accessData: any = jwt_decode(accessToken);
  const idData: any = decodeOrEmpty(idToken);
  const profile = readSessionProfile();
  return {
    role: accessData['https://dosen.io/role']?.role ?? profile?.role ?? undefined,
    organization: accessData['https://dosen.io/organization'] ?? profile?.organization ?? undefined,
    userMetadata: profile ? { ...(idData.user_metadata ?? {}), ...profile.user_metadata } : idData.user_metadata,
    accessData,
    idData
  };
}
